export const StateName = 'OrgContextState';

export interface OrgContextState {
  org_name?: string;
}

export const initialState: OrgContextState = {
  org_name: null
};
